import { render, staticRenderFns } from "./Models.vue?vue&type=template&id=a21370bc&"
import script from "./Models.vue?vue&type=script&lang=js&"
export * from "./Models.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Models.vue"
export default component.exports